import {
  H_04,
  HERO_DEFAULTS,
  hideH04Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const H04_PLASMIC_PROPS = {
  h04Eyebrow: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_04].eyebrow,
    description: "Eyebrow text (H04 only)",
    hidden: hideH04Props,
  },
  h04Heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_04].heading,
    description: "Main heading (H04 only)",
    hidden: hideH04Props,
  },
  h04Description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_04].description,
    description: "Description text (H04 only)",
    hidden: hideH04Props,
  },
  h04PrimaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_04].primaryButtonText,
    description: "Primary button text (H04 only)",
    hidden: hideH04Props,
  },
  h04PrimaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
    hidden: hideH04Props,
  },
  h04PrimaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open primary button in new tab (H04 only)",
    hidden: hideH04Props,
  },
  h04PrimaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH04Props(props) ||
      (props.h04PrimaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.h04PrimaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  h04PrimaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH04Props(props) ||
      (props.h04PrimaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.h04PrimaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  h04Image: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_04].image,
    description: "Hero image (H04 only)",
    hidden: hideH04Props,
  },
  h04ImageAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_04].imageAlt,
    description: "Image alt text (H04 only)",
    hidden: hideH04Props,
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
